import React from 'react'
import OKSelect from 'components/commons/OKSelect/OKSelect'
import PropTypes from "prop-types";
import { recordLinkV2 } from "utilities/tagging";
import { UPLOAD_DOCUMENTATION } from "constants/tagging";
import { getProcessOptions } from "./getProcessOptions";
import { translateText } from "../../../getTranslationsMyProfileUploadDocumentation";

export const ProcessSelector = ({ value, originCountry, onChange }) => {
    const recordEvent = (eventLabel) => {
        recordLinkV2({
            categoriaEvento: UPLOAD_DOCUMENTATION,
            accionEvento: "dropdown/escoger proceso",
            etiquetaEvento: eventLabel
        });
    }
    const handleOnChange = (processSelected) => {
        onChange(processSelected)
        recordEvent(processSelected.label)
    }

    const handleOnOpenMenu = () => {
        recordEvent("abrir")
    }

    return (
        <div onClick={handleOnOpenMenu}>
            <OKSelect
                name="account-chequebook-movements-header-dropdown"
                onChange={handleOnChange}
                value={value}
                options={getProcessOptions(originCountry)}
                searchable={false}
                clearable={false}
                label={translateText('comboTitle')}
                placeholder={translateText('comboPlaceHolder')}
            />
        </div>
    );
}

ProcessSelector.propTypes = {
    value: PropTypes.string,
    originCountry: PropTypes.string,
    onChange: PropTypes.func
}